import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FolderKanban } from "lucide-react";
import AppShell from "../components/AppShell";
import EmptyState from "../components/EmptyState";
import { useAuth } from "../lib/auth";
import { projectApi, roleLabel, errText, EXTERNAL_COMPANY } from "../lib/projectAccess";

const card = "block bg-white border border-erf-borderCream rounded-md p-4 min-h-[44px] hover:border-erf-gold focus:outline-none focus:ring-2 focus:ring-erf-gold transition-colors";

export default function MyProjects() {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { projectApi.mine().then((r) => setData(r.data)).catch((e) => setErr(errText(e))); }, []);
  const external = EXTERNAL_COMPANY.includes(user?.role_key);

  return (
    <AppShell title="My Projects" subtitle="Projects you are assigned to">
      <div className="mx-auto w-full max-w-[1100px] px-4 md:px-6" data-testid="my-projects-page">
        {err && <div className="text-sm text-red-700" role="alert" data-testid="my-projects-error">{err}</div>}
        {!data && !err && <div className="font-mono text-xs text-erf-dark/60" data-testid="my-projects-loading">Loading…</div>}
        {data?.company_wide && (
          <p className="mb-3 text-xs text-erf-dark/70" data-testid="my-projects-company-wide">
            You can view every company project. The list below shows the ones you are assigned to.
          </p>
        )}
        {data && data.assignments.length === 0 && (
          <EmptyState icon={FolderKanban} title="You're not on any project yet"
            subtitle="Your project manager adds you to the projects you work on." />
        )}
        <ul className="grid gap-3 sm:grid-cols-2" data-testid="my-projects-list">
          {(data?.assignments || []).map((a) => (
            <li key={`${a.project_id}:${a.role_on_project}`} className="grid gap-2">
              <Link to={`/projects/${a.project_id}`} className={card} data-testid={`my-projects-item-${a.project_id}`}>
                <div className="font-nav text-sm font-semibold text-erf-dark">{a.project_name || "Untitled project"}</div>
                <div className="text-xs text-erf-dark/70 mt-1">
                  {roleLabel(a.role_on_project)} · since {(a.assigned_at || "").slice(0, 10)}
                </div>
              </Link>
              {external && (
                <Link to={`/projects/${a.project_id}/my-subcontract`}
                  className="inline-flex items-center min-h-[44px] px-3 text-xs font-nav text-erf-dark underline focus:outline-none focus:ring-2 focus:ring-erf-gold rounded"
                  data-testid={`my-projects-subcontract-${a.project_id}`}>My subcontract</Link>
              )}
            </li>
          ))}
        </ul>
      </div>
    </AppShell>
  );
}
